import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const breadcrumbItems = [
    { label: '首页', href: '/' },
    ...items,
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.href ? `https://www.91selfie.com${item.href}` : undefined,
    })),
  };

  const getCategoryName = (slug: string): string => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : slug;
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 flex-wrap">
        {breadcrumbItems.map((item, index) => {
          const isLast = index === breadcrumbItems.length - 1;
          const displayLabel = item.href?.startsWith('/category/')
            ? getCategoryName(item.href.replace('/category/', ''))
            : item.label;

          return (
            <span key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
                </div>
              )}
              {isLast || !item.href ? (
                <span className="text-foreground-700 font-medium">{displayLabel}</span>
              ) : (
                <Link to={item.href} className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                  {displayLabel}
                </Link>
              )}
            </span>
          );
        })}
      </nav>
    </>
  );
}